import { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate, redirect } from 'react-router-dom'

import { AppShell } from '@/components/layout/app-shell'
import { api } from '@/lib/api-client'
import { hasAnyPermission } from '@/lib/permissions'

// Lazy imports pra code splitting
const LoginPage = lazy(() =>
  import('@/features/auth/components/login-page').then((m) => ({ default: m.LoginPage })),
)
const CandidaturaPublicaRoute = lazy(() =>
  import('@/features/candidatura-publica/components/candidatura-publica-route').then((m) => ({
    default: m.CandidaturaPublicaRoute,
  })),
)
const CargosPage = lazy(() =>
  import('@/features/cargos/components/cargos-page').then((m) => ({ default: m.CargosPage })),
)
const CargoFormPage = lazy(() =>
  import('@/features/cargos/components/cargo-form-page').then((m) => ({
    default: m.CargoFormPage,
  })),
)
const MapeamentoCargoDpPage = lazy(() =>
  import('@/features/cargos-mapeamento-dp/components/mapeamento-cargo-dp-page').then((m) => ({
    default: m.MapeamentoCargoDpPage,
  })),
)
const UsuariosPage = lazy(() =>
  import('@/features/usuarios/components/usuarios-page').then((m) => ({
    default: m.UsuariosPage,
  })),
)
const TiposVagasPage = lazy(() =>
  import('@/features/tipos-vagas/components/tipos-vagas-page').then((m) => ({
    default: m.TiposVagasPage,
  })),
)
const ModelosPropostaPage = lazy(() =>
  import('@/features/modelos-proposta/components/modelos-proposta-page').then((m) => ({
    default: m.ModelosPropostaPage,
  })),
)
const VagasPage = lazy(() =>
  import('@/features/vagas/components/vagas-page').then((m) => ({ default: m.VagasPage })),
)
const VagaFormPage = lazy(() =>
  import('@/features/vagas/components/vaga-form-page').then((m) => ({
    default: m.VagaFormPage,
  })),
)
const SolicitacoesPage = lazy(() =>
  import('@/features/solicitacoes/components/solicitacoes-page').then((m) => ({
    default: m.SolicitacoesPage,
  })),
)
const NovaSolicitacaoPage = lazy(() =>
  import('@/features/solicitacoes/components/nova-solicitacao-page').then((m) => ({
    default: m.NovaSolicitacaoPage,
  })),
)
const CaixaSolicitacoesPage = lazy(() =>
  import('@/features/solicitacoes/components/caixa-solicitacoes-page').then((m) => ({
    default: m.CaixaSolicitacoesPage,
  })),
)
const IntegracoesPage = lazy(() =>
  import('@/features/integracoes/components/integracoes-page').then((m) => ({
    default: m.IntegracoesPage,
  })),
)
const TriagemLandingPage = lazy(() =>
  import('@/features/triagem/components/triagem-landing-page').then((m) => ({
    default: m.TriagemLandingPage,
  })),
)
const TriagemDaVagaPage = lazy(() =>
  import('@/features/triagem/components/triagem-da-vaga-page').then((m) => ({
    default: m.TriagemDaVagaPage,
  })),
)
const KanbanLandingPage = lazy(() =>
  import('@/features/kanban/components/kanban-landing-page').then((m) => ({
    default: m.KanbanLandingPage,
  })),
)
const KanbanPage = lazy(() =>
  import('@/features/kanban/components/kanban-page').then((m) => ({ default: m.KanbanPage })),
)
const CandidatosSelecionadosPage = lazy(() =>
  import('@/features/kanban/components/candidatos-selecionados-page').then((m) => ({
    default: m.CandidatosSelecionadosPage,
  })),
)
const Detalhe360Page = lazy(() =>
  import('@/features/kanban/components/detalhe-360-page').then((m) => ({
    default: m.Detalhe360Page,
  })),
)
const ColaboradoresDpPage = lazy(() =>
  import('@/features/colaboradores-dp/components/colaboradores-dp-page').then((m) => ({
    default: m.ColaboradoresDpPage,
  })),
)
const ColaboradorDpDetalhePage = lazy(() =>
  import('@/features/colaboradores-dp/components/colaborador-dp-detalhe-page').then((m) => ({
    default: m.ColaboradorDpDetalhePage,
  })),
)
const FeedbacksPage = lazy(() =>
  import('@/features/feedbacks/components/feedbacks-page').then((m) => ({
    default: m.FeedbacksPage,
  })),
)
const FeedbacksRelatoriosPage = lazy(() =>
  import('@/features/feedbacks/components/feedbacks-relatorios-page').then((m) => ({
    default: m.FeedbacksRelatoriosPage,
  })),
)
const FeedbacksDashboardPage = lazy(() =>
  import('@/features/feedbacks/components/feedbacks-dashboard-page').then((m) => ({
    default: m.FeedbacksDashboardPage,
  })),
)
const TodosFeedbacksPage = lazy(() =>
  import('@/features/feedbacks/components/todos-feedbacks-page').then((m) => ({
    default: m.TodosFeedbacksPage,
  })),
)
const PdisPage = lazy(() =>
  import('@/features/pdis/components/pdis-page').then((m) => ({
    default: m.PdisPage,
  })),
)
const AvaliacaoDesempenhoPage = lazy(() =>
  import('@/features/avaliacao-desempenho/components/avaliacao-desempenho-page').then((m) => ({
    default: m.AvaliacaoDesempenhoPage,
  })),
)
const CompetenciasPage = lazy(() =>
  import('@/features/competencias/components/competencias-page').then((m) => ({
    default: m.CompetenciasPage,
  })),
)
const MantrasPage = lazy(() =>
  import('@/features/mantras/components/mantras-page').then((m) => ({
    default: m.MantrasPage,
  })),
)
const CiclosAvaliacaoPage = lazy(() =>
  import('@/features/ciclos-avaliacao/components/ciclos-avaliacao-page').then((m) => ({
    default: m.CiclosAvaliacaoPage,
  })),
)
const CicloAvaliacaoDetalhePage = lazy(() =>
  import('@/features/ciclos-avaliacao/components/ciclo-avaliacao-detalhe-page').then((m) => ({
    default: m.CicloAvaliacaoDetalhePage,
  })),
)
const ParticipanteCicloDetalhePage = lazy(() =>
  import('@/features/participantes-ciclo/components/participante-ciclo-detalhe-page').then(
    (m) => ({
      default: m.ParticipanteCicloDetalhePage,
    }),
  ),
)
const CalibragemPage = lazy(() =>
  import('@/features/calibragem/components/calibragem-page').then((m) => ({
    default: m.CalibragemPage,
  })),
)
const CalibragemDetalhePage = lazy(() =>
  import('@/features/calibragem/components/calibragem-detalhe-page').then((m) => ({
    default: m.CalibragemDetalhePage,
  })),
)
const ResultadoAvaliacaoPage = lazy(() =>
  import('@/features/resultados-avaliacao/components/resultado-avaliacao-page').then((m) => ({
    default: m.ResultadoAvaliacaoPage,
  })),
)
const NineBoxPage = lazy(() =>
  import('@/features/nine-box/components/nine-box-page').then((m) => ({
    default: m.NineBoxPage,
  })),
)
const NineBoxDetalhePage = lazy(() =>
  import('@/features/nine-box/components/nine-box-detalhe-page').then((m) => ({
    default: m.NineBoxDetalhePage,
  })),
)
const PerfisPage = lazy(() =>
  import('@/features/perfis/components/perfis-page').then((m) => ({
    default: m.PerfisPage,
  })),
)
const PerfilFormPage = lazy(() =>
  import('@/features/perfis/components/perfil-form-page').then((m) => ({
    default: m.PerfilFormPage,
  })),
)
const BancoTalentosPage = lazy(() =>
  import('@/features/banco-talentos/components/banco-talentos-page').then((m) => ({
    default: m.BancoTalentosPage,
  })),
)
const QuadrosCarreiraPage = lazy(() =>
  import('@/features/quadro-carreira/components/quadros-carreira-page').then((m) => ({
    default: m.QuadrosCarreiraPage,
  })),
)
const QuadroCarreiraFormPage = lazy(() =>
  import('@/features/quadro-carreira/components/quadro-carreira-form-page').then((m) => ({
    default: m.QuadroCarreiraFormPage,
  })),
)
const QuadroCarreiraDetalhePage = lazy(() =>
  import('@/features/quadro-carreira/components/quadro-carreira-detalhe-page').then((m) => ({
    default: m.QuadroCarreiraDetalhePage,
  })),
)
const DashboardRouteIndex = lazy(() =>
  import('@/features/dashboard/components/dashboard-route-index').then((m) => ({
    default: m.DashboardRouteIndex,
  })),
)
const FormularioAvaliacaoPage = lazy(() =>
  import('@/features/avaliacoes-ciclo/components/formulario-avaliacao-page').then((m) => ({
    default: m.FormularioAvaliacaoPage,
  })),
)
const RelatoriosGerenciaisPage = lazy(() =>
  import('@/features/relatorios-gerenciais/components/relatorios-gerenciais-page').then((m) => ({
    default: m.RelatoriosGerenciaisPage,
  })),
)
const PesquisasClimaPage = lazy(() =>
  import('@/features/pesquisa-clima/components/pesquisas-clima-page').then((m) => ({
    default: m.PesquisasClimaPage,
  })),
)
const ResultadoPesquisaClimaPage = lazy(() =>
  import('@/features/pesquisa-clima/components/resultado-pesquisa-clima-page').then((m) => ({
    default: m.ResultadoPesquisaClimaPage,
  })),
)
const CompararPesquisasClimaPage = lazy(() =>
  import('@/features/pesquisa-clima/components/comparar-pesquisas-clima-page').then((m) => ({
    default: m.CompararPesquisasClimaPage,
  })),
)
const RespostaClimaPage = lazy(() =>
  import('@/features/pesquisa-clima/components/resposta-clima-page').then((m) => ({
    default: m.RespostaClimaPage,
  })),
)
interface SessionUser {
  id: string
  email: string
  name: string
  permissions: readonly string[]
  [k: string]: unknown
}

async function fetchSessionUser(): Promise<SessionUser | null> {
  try {
    const { data } = await api.get<{ user?: SessionUser } | null>('/api/auth/get-session')
    return data?.user ?? null
  } catch {
    return null
  }
}

async function privateLoader() {
  const user = await fetchSessionUser()
  if (!user) {
    const next = encodeURIComponent(window.location.pathname + window.location.search)
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect(`/sign-in?next=${next}`)
  }
  return user
}

function makePermissionLoader(required: readonly string[]) {
  return async () => {
    const user = await fetchSessionUser()
    if (!user) {
      const next = encodeURIComponent(window.location.pathname + window.location.search)
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect(`/sign-in?next=${next}`)
    }
    if (!hasAnyPermission(user.permissions, required)) {
      // Sem permissão → redireciona pra raiz do app (sem 403 page dedicada nesta fatia)
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect('/app')
    }
    return user
  }
}

// Fallback de loading mínimo pra suspense
function PageLoader() {
  return (
    <div className="flex h-64 items-center justify-center text-sm text-muted-foreground">
      Carregando…
    </div>
  )
}

export const router = createBrowserRouter([
  // Rota raiz → redireciona pro sign-in
  {
    path: '/',
    children: [{ index: true, element: <Navigate to="/sign-in" replace /> }],
  },

  // Auth
  {
    path: '/sign-in',
    element: (
      <Suspense fallback={<PageLoader />}>
        <LoginPage />
      </Suspense>
    ),
  },

  // Shell privado
  {
    id: 'app-shell',
    path: '/app',
    element: <AppShell />,
    loader: privateLoader,
    children: [
      {
        index: true,
        // Sem loader de permissão aqui para evitar loop de redirect:
        // makePermissionLoader lançaria redirect('/app') para usuários sem
        // view:dashboard, o que faria o índice de /app redirecionar para /app
        // → loop infinito. O privateLoader do shell pai já autentica o usuário;
        // a decisão view:dashboard vs boas-vindas acontece dentro do componente.
        element: (
          <Suspense fallback={<PageLoader />}>
            <DashboardRouteIndex />
          </Suspense>
        ),
      },
      {
        path: 'cargos',
        loader: makePermissionLoader(['view:cargos']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CargosPage />
          </Suspense>
        ),
      },
      {
        path: 'cargos/novo',
        loader: makePermissionLoader(['manage:cargos']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CargoFormPage />
          </Suspense>
        ),
      },
      {
        path: 'cargos/:cargoId/editar',
        loader: makePermissionLoader(['manage:cargos']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CargoFormPage />
          </Suspense>
        ),
      },
      {
        path: 'cargos/mapeamento-dp',
        loader: makePermissionLoader(['manage:cargos']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <MapeamentoCargoDpPage />
          </Suspense>
        ),
      },
      {
        path: 'usuarios',
        loader: makePermissionLoader(['view:usuarios']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <UsuariosPage />
          </Suspense>
        ),
      },
      {
        path: 'tipos-vagas',
        loader: makePermissionLoader(['view:tipos-vagas']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <TiposVagasPage />
          </Suspense>
        ),
      },
      {
        path: 'modelos-proposta',
        loader: makePermissionLoader(['view:propostas']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <ModelosPropostaPage />
          </Suspense>
        ),
      },
      {
        path: 'vagas',
        loader: makePermissionLoader(['view:vagas']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <VagasPage />
          </Suspense>
        ),
      },
      {
        path: 'vagas/nova',
        loader: makePermissionLoader(['manage:vagas']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <VagaFormPage />
          </Suspense>
        ),
      },
      {
        path: 'vagas/:id',
        loader: makePermissionLoader(['manage:vagas']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <VagaFormPage />
          </Suspense>
        ),
      },
      {
        path: 'solicitacoes',
        loader: makePermissionLoader(['view:solicitacoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <SolicitacoesPage />
          </Suspense>
        ),
      },
      {
        path: 'solicitacoes/nova',
        loader: makePermissionLoader(['view:solicitacoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <NovaSolicitacaoPage />
          </Suspense>
        ),
      },
      {
        path: 'caixa-solicitacoes',
        loader: makePermissionLoader(['manage:solicitacoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CaixaSolicitacoesPage />
          </Suspense>
        ),
      },
      {
        path: 'configuracoes/integracoes',
        loader: makePermissionLoader(['view:integracoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <IntegracoesPage />
          </Suspense>
        ),
      },
      {
        path: 'triagem',
        loader: makePermissionLoader(['view:triagem']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <TriagemLandingPage />
          </Suspense>
        ),
      },
      {
        path: 'kanban',
        loader: makePermissionLoader(['view:kanban']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <KanbanLandingPage />
          </Suspense>
        ),
      },
      {
        path: 'vagas/:vagaId/triagem',
        loader: makePermissionLoader(['view:triagem']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <TriagemDaVagaPage />
          </Suspense>
        ),
      },
      {
        path: 'vagas/:vagaId/kanban',
        loader: makePermissionLoader(['view:kanban']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <KanbanPage />
          </Suspense>
        ),
      },
      {
        path: 'vagas/:vagaId/kanban/candidatura/:candidaturaId',
        loader: makePermissionLoader(['view:kanban']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <Detalhe360Page />
          </Suspense>
        ),
      },
      {
        path: 'candidatos-selecionados',
        loader: makePermissionLoader(['view:kanban']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CandidatosSelecionadosPage />
          </Suspense>
        ),
      },
      {
        path: 'colaboradores',
        loader: makePermissionLoader(['view:funcionarios']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <ColaboradoresDpPage />
          </Suspense>
        ),
      },
      {
        path: 'colaboradores/:id',
        loader: makePermissionLoader(['view:funcionarios']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <ColaboradorDpDetalhePage />
          </Suspense>
        ),
      },
      {
        path: 'feedbacks',
        loader: makePermissionLoader(['view:feedbacks']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <FeedbacksPage />
          </Suspense>
        ),
      },
      {
        path: 'feedbacks/relatorios',
        loader: makePermissionLoader(['view:feedbacks']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <FeedbacksRelatoriosPage />
          </Suspense>
        ),
      },
      {
        path: 'feedbacks/dashboard',
        loader: makePermissionLoader(['view:feedbacks']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <FeedbacksDashboardPage />
          </Suspense>
        ),
      },
      {
        path: 'feedbacks/todos',
        loader: makePermissionLoader(['view:all-feedbacks']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <TodosFeedbacksPage />
          </Suspense>
        ),
      },
      {
        path: 'pdis',
        loader: makePermissionLoader(['view:pdis']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <PdisPage />
          </Suspense>
        ),
      },
      {
        path: 'avaliacao-desempenho',
        loader: makePermissionLoader(['view:avaliacao-desempenho']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <AvaliacaoDesempenhoPage />
          </Suspense>
        ),
      },
      {
        path: 'competencias',
        loader: makePermissionLoader(['view:competencias']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CompetenciasPage />
          </Suspense>
        ),
      },
      {
        path: 'mantras',
        loader: makePermissionLoader(['manage:mantras']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <MantrasPage />
          </Suspense>
        ),
      },
      {
        path: 'ciclos-avaliacao',
        loader: makePermissionLoader(['manage:ciclos-avaliacao', 'calibrar:avaliacoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CiclosAvaliacaoPage />
          </Suspense>
        ),
      },
      {
        path: 'ciclos-avaliacao/:id',
        loader: makePermissionLoader(['manage:ciclos-avaliacao', 'calibrar:avaliacoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CicloAvaliacaoDetalhePage />
          </Suspense>
        ),
      },
      {
        path: 'ciclos-avaliacao/:cicloId/calibragem',
        loader: makePermissionLoader(['calibrar:avaliacoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CalibragemPage />
          </Suspense>
        ),
      },
      {
        path: 'ciclos-avaliacao/:cicloId/participantes/:participanteId',
        loader: makePermissionLoader(['manage:ciclos-avaliacao']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <ParticipanteCicloDetalhePage />
          </Suspense>
        ),
      },
      {
        path: 'ciclos-avaliacao/:cicloId/participantes/:participanteId/calibragem',
        loader: makePermissionLoader(['calibrar:avaliacoes']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CalibragemDetalhePage />
          </Suspense>
        ),
      },
      {
        path: 'ciclos-avaliacao/:cicloId/participantes/:participanteId/resultado',
        loader: makePermissionLoader(['view:avaliacao-desempenho']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <ResultadoAvaliacaoPage />
          </Suspense>
        ),
      },
      {
        path: 'nine-box',
        loader: makePermissionLoader(['view:nine-box', 'manage:nine-box']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <NineBoxPage />
          </Suspense>
        ),
      },
      {
        path: 'ciclos-avaliacao/:cicloId/participantes/:participanteId/nine-box',
        loader: makePermissionLoader(['view:nine-box', 'manage:nine-box']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <NineBoxDetalhePage />
          </Suspense>
        ),
      },
      {
        path: 'minhas-avaliacoes/:avaliadorDesignadoId',
        loader: makePermissionLoader(['avaliar:desempenho']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <FormularioAvaliacaoPage />
          </Suspense>
        ),
      },
      {
        path: 'perfis',
        loader: makePermissionLoader(['view:perfis']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <PerfisPage />
          </Suspense>
        ),
      },
      {
        path: 'perfis/nova',
        loader: makePermissionLoader(['manage:perfis']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <PerfilFormPage />
          </Suspense>
        ),
      },
      {
        path: 'perfis/:id',
        loader: makePermissionLoader(['manage:perfis']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <PerfilFormPage />
          </Suspense>
        ),
      },
      {
        path: 'banco-talentos',
        loader: makePermissionLoader(['view:banco-talentos']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <BancoTalentosPage />
          </Suspense>
        ),
      },
      {
        path: 'quadros-carreira',
        loader: makePermissionLoader(['view:quadro-carreira', 'manage:quadro-carreira']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <QuadrosCarreiraPage />
          </Suspense>
        ),
      },
      {
        path: 'quadros-carreira/novo',
        loader: makePermissionLoader(['manage:quadro-carreira']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <QuadroCarreiraFormPage />
          </Suspense>
        ),
      },
      {
        path: 'quadros-carreira/:id',
        loader: makePermissionLoader(['view:quadro-carreira', 'manage:quadro-carreira']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <QuadroCarreiraDetalhePage />
          </Suspense>
        ),
      },
      {
        path: 'quadros-carreira/:id/editar',
        loader: makePermissionLoader(['manage:quadro-carreira']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <QuadroCarreiraFormPage />
          </Suspense>
        ),
      },
      {
        path: 'relatorios-gerenciais',
        loader: makePermissionLoader(['view:relatorios-gerenciais']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <RelatoriosGerenciaisPage />
          </Suspense>
        ),
      },
      {
        path: 'pesquisa-clima',
        loader: makePermissionLoader(['manage:pesquisa-clima']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <PesquisasClimaPage />
          </Suspense>
        ),
      },
      {
        path: 'pesquisa-clima/comparar',
        loader: makePermissionLoader(['manage:pesquisa-clima']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <CompararPesquisasClimaPage />
          </Suspense>
        ),
      },
      {
        path: 'pesquisa-clima/:id/resultados',
        loader: makePermissionLoader(['manage:pesquisa-clima']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <ResultadoPesquisaClimaPage />
          </Suspense>
        ),
      },
      {
        path: 'pesquisa-clima/responder',
        loader: makePermissionLoader(['responder:pesquisa-clima']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <RespostaClimaPage />
          </Suspense>
        ),
      },
      {
        path: 'pesquisa-clima/responder/:pesquisaId',
        loader: makePermissionLoader(['responder:pesquisa-clima']),
        element: (
          <Suspense fallback={<PageLoader />}>
            <RespostaClimaPage />
          </Suspense>
        ),
      },
    ],
  },

  {
    path: '/candidatura/:vagaId',
    element: (
      <Suspense fallback={<PageLoader />}>
        <CandidaturaPublicaRoute />
      </Suspense>
    ),
  },

  // Catch-all
  { path: '*', element: <Navigate to="/" replace /> },
])
